<template>
  <div
    style="height:100%"
    class="pt-2"
    @mouseover="isVisible = true"
    @mouseleave="isVisible = false"
  >
    <div class="addItem">
      <b-button
        variant="primary"
        @click.prevent="emitAdd"
        size="sm"
        v-if="isVisible"
        ><i class="fas fa-plus mr-2"></i> Add</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: { provider: null, day: null },
  methods: {
    emitAdd() {
      this.$emit("add", { day: this.day, provider: this.provider });
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
};
</script>
